import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function ProtectedRoute({ children }) {
  const { admin, checked, authError, refresh } = useAdminAuth();

  if (checked && authError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-4 text-center" dir="rtl">
        <p role="alert" className="text-muted-foreground">تعذّر التحقق من الجلسة بسبب مشكلة اتصال. لم تُمسح الجلسة.</p>
        <button type="button" onClick={refresh} className="rounded-xl bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground">
          إعادة المحاولة
        </button>
      </div>
    );
  }

  if (!checked || admin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
